module.exports = __webpack_public_path__ + "static/media/tail.bc77fba8.png";